import { attachErrorHandler } from '@sentry/vue'

export function useAppContext() {
  function mountAppContext(apps: any) {
    for (const iterator in apps) {
      attachErrorHandler(apps[iterator], {} as any)
      window[iterator] = apps[iterator]
    }
  }
  return { mountAppContext }
}